const readImportMetaEnv = () => {
  try {
    return new Function(
      "try { return (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : undefined; } catch (_) { return undefined; }"
    )();
  } catch (error) {
    return undefined;
  }
};

const normalizeServerUrl = (value) => {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }

  if (typeof window === "undefined") {
    return raw.replace(/\/$/, "");
  }

  const { protocol, hostname, origin } = window.location;

  // Handle malformed values such as ":8080/app".
  if (raw.startsWith(":")) {
    return `${protocol}//${hostname}${raw}`.replace(/\/$/, "");
  }
  if (raw.startsWith("//")) {
    return `${protocol}${raw}`.replace(/\/$/, "");
  }
  if (raw.startsWith("/")) {
    return `${origin}${raw}`.replace(/\/$/, "");
  }

  // If scheme is missing but looks like host[:port]/path, assume current protocol.
  if (!/^https?:\/\//i.test(raw) && /^[A-Za-z0-9.-]+(:\d+)?(\/.*)?$/.test(raw)) {
    return `${protocol}//${raw}`.replace(/\/$/, "");
  }

  return raw.replace(/\/$/, "");
};

const guessServerUrlFallback = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const { protocol, hostname, port, origin } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    if (port === "3001" || port === "3000") {
      return `${protocol}//${hostname}:8080/app`;
    }
  }

  const fromStorage = window.localStorage.getItem("baseUrl");
  if (fromStorage) {
    return normalizeServerUrl(fromStorage);
  }

  return normalizeServerUrl(`${origin}/api/app`);
};

const readEnv = (primaryKey, fallbackKey, defaultValue = "") => {
  const importMetaEnv = readImportMetaEnv();
  const processEnv = typeof process !== "undefined" ? process.env : undefined;

  const primary = processEnv?.[primaryKey] ?? importMetaEnv?.[primaryKey];
  if (primary !== undefined && primary !== "") {
    return primary;
  }

  const fallback = (fallbackKey ? processEnv?.[fallbackKey] : undefined) ?? (fallbackKey ? importMetaEnv?.[fallbackKey] : undefined);
  if (fallback !== undefined && fallback !== "") {
    return fallback;
  }

  return defaultValue;
};

export const env = {
  serverUrl: normalizeServerUrl(
    process.env.REACT_APP_SERVERURL ||
      readEnv("VITE_SERVER_URL", null, guessServerUrlFallback())
  ),
  appId:
    process.env.REACT_APP_APPID ||
    readEnv("VITE_APP_ID", null, "opensign")
};

if (!env.serverUrl) {
  throw new Error(
    "Missing server URL. Set REACT_APP_SERVERURL now (or VITE_SERVER_URL for the Vite migration)."
  );
}
